import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { getQueryStringFromObject } from '../../../../../../common/utils';
import { ListServerPaginationStateModel } from '../../../../../../common';
import { PartnerBrief, PartnerServiceType, PartnerType } from '../../../../administration';
import { WrapperHttpService } from '../../../../../services/wrapper-http-service';
import { API_URL } from '../../../../../../services/config';
import { FailedMessagesEndpoint } from '../../constants/failed-messages-endpoint';
import {
  FailedMessagesProfileItemFilterModel,
  FailedMessagesProfileItemModel,
} from '../../models/profile/failed-messages-profile-item.model';

@Injectable({
  providedIn: 'root',
})
export class FailedMessagesProfileItemBriefService {
  constructor(private http: WrapperHttpService) {}

  getProfile(id: number): Observable<FailedMessagesProfileItemFilterModel> {
    const url = `${API_URL}${FailedMessagesEndpoint.Base}${FailedMessagesEndpoint.Profiles}/${id}`;
    return this.http.withLoading().get<FailedMessagesProfileItemFilterModel>(url);
  }

  updateProfile(body: FailedMessagesProfileItemModel): Observable<FailedMessagesProfileItemModel> {
    const url = `${API_URL}${FailedMessagesEndpoint.Base}${FailedMessagesEndpoint.Profiles}`;
    return this.http.withLoading().patch<FailedMessagesProfileItemModel>(url, body);
  }

  deleteProfile(profileId: number): Observable<FailedMessagesProfileItemModel> {
    const url = `${API_URL}${FailedMessagesEndpoint.Base}${FailedMessagesEndpoint.Profiles}/${profileId}`;
    return this.http.withLoading().delete<FailedMessagesProfileItemModel>(url);
  }

  getPartnerList(serviceId: string): Observable<ListServerPaginationStateModel<PartnerBrief>> {
    const body = {
      serviceId,
      serviceType: PartnerServiceType.Tms,
      active: null,
      country: null,
      approvalStatus: null,
      partnerType: PartnerType.Carrier,
      shortName: null,
    };
    const url = `${API_URL}${FailedMessagesEndpoint.Partners}${
      FailedMessagesEndpoint.Search
    }?${getQueryStringFromObject({ page: 0, size: 10 })}`;

    return this.http.withLoading().post<ListServerPaginationStateModel<PartnerBrief>>(url, body);
  }
}
